module.exports = __webpack_public_path__ + "img/chair-filter.0821cb33.svg";